import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListarDeclaracoesFiscaisComponent } from './listar-declaracoes-fiscais/listar-declaracoes-fiscais.component';
import { DetalhesDeclaracoesFiscaisComponent } from './detalhes-declaracoes-fiscais/detalhes-declaracoes-fiscais.component';

const routes: Routes = [
  { path: 'listar-declaracoes-fiscais', component: ListarDeclaracoesFiscaisComponent },
  { path: 'detalhes-declaracoes-fiscais', component: DetalhesDeclaracoesFiscaisComponent }, 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeclaracoesFiscaisRoutingModule {}
